/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router, Route, Routes,} from 'react-router-dom';
import 'jquery';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import '@corero/ssp-ui-components/assets/styles/fonts.css';
import '@corero/ssp-ui-components/assets/fonts/helveticaNeueLtStdBold.otf';
import '@corero/ssp-ui-components/assets/fonts/avenirLtStdRoman.otf';
import 'react-datetime/css/react-datetime.css';
import '@corero/ssp-ui-components/assets/styles/global.scss';
import '@corero/ssp-ui-components/assets/styles/mspicons.css';
import '@corero/ssp-ui-components/core/polyfills.js';

import App from './App';
import NotFound from '@corero/ssp-ui-components/pages/notFound/NotFound';
import Login from './pages/login/Login';
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import ForgotPassword2 from './pages/forgotPassword/ForgotPassword2';
import ApplyToken from './pages/applyToken/ApplyToken';
import GlobalHelmet from "@corero/ssp-ui-components/components/globalHelmet/GlobalHelmet";
import SsoLogin from "./pages/ssoLogin/SsoLogin";
import {Provider} from "react-redux";
import reduxStore from './store/store';

const app = (
    <Provider store={reduxStore}>
        <GlobalHelmet/>
        <Router>
            <Routes>
                <Route path="/login/" element={<App/>}>
                    <Route index element={<Login/>}/>
                    <Route path="login" element={<Login/>}/>
                    <Route path="forgot-password-1" element={<ForgotPassword/>}/>
                    <Route path="forgot-password-2" element={<ForgotPassword2/>}/>
                    <Route path="apply-token" element={<ApplyToken/>}/>
                    <Route path="sso-login" element={<SsoLogin/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Route>
            </Routes>
        </Router>
    </Provider>
);

if (process.env.NODE_ENV === 'production') {
    createRoot(document.getElementById('root')).render(app);
} else {
    const renderApp = () => createRoot(document.getElementById('root')).render(app);

    if (module.hot) {
        module.hot.accept();
        renderApp();
    }
}
